import { render, staticRenderFns } from "./completa.vue?vue&type=template&id=600375d2&"
import script from "./completa.ts?vue&type=script&lang=ts&"
export * from "./completa.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports